import { query } from './query'

export const pageQuery = {
  query,
  mocks: {
    defaultData: null,
  },
}
